import { camelCase, set } from 'lodash';

import { type Scopes } from './model';

export const parseScopes = (tokenScopes: string[]) =>
  tokenScopes.reduce((o, k) => set(o, camelCase(k.replace('vitalstatistix.', '')), true), {}) as Scopes;
